import { createSelector } from 'reselect'

import { reservationsSelector } from '../selectors'

export const reservationsExistSelector = createSelector(
  reservationsSelector,
  (reservations) => reservations !== undefined && reservations.length > 0
)
